import React from "react";
import { useLocation } from "react-router-dom";
import "./HomeAboutSec.css";

// IMPORT ENGLISH DATA
import {
  aboutData,
  servicesData,
  industriesData,
  oilAndGasData,
  powerAndUtilitiesData,
  wasteManagementData,
  miningAndMineralsData,
  assetManagementData,
  bankingData,
  financialAdvisoryData,
  financialServicesTaxData,
  fintechData,
  insuranceData,
  healthcareData,
  lifeScienceData,
  privateEquityData,
  professionalServiceData,
  publicSectorData,
  realEstateConstructionData,
  mediaAndEntertainmentData,
  technologyData,
  telecommunicationData,
  financialStatementAuditData,
  ifrsAdvisoryServiceData,
  otherAssuranceServiceData,
  internalControlFrameworkData,
  dealAdvisoryData,
  restructuringData,
  dueDiligenceData,
  forensicServicesData,
  riskAdvisoryData,
  technologyAdvisoryServiceData,
  valuationsData,
  corporatetaxData,
  mergerandacquisitionData,
  transferpricingData,
  valueaddedtaxData,
  internationaltaxData,
  excisetaxData,
  taxrestructuringData,
  economicsubstanceregulationsData,
  marketResearchData,
  businessConsultingData,
  entitySetupData,
  outsourcedFinanceRegulatoryComplianceData,
  companySecretarialData,
  financeAndAccountingData,
  corporateAdvisoryServicesData,
  expensesClaimManagementData,
  payrollHrServicesData,
  secondmentData,
  treasuryServiceData,
} from "../../../Data/HomeAboutSecData";

// IMPORT FRENCH DATA
import {
  aboutDataFR,
  servicesDataFR,
  industriesDataFR,
  oilAndGasDataFR,
  powerAndUtilitiesDataFR,
  wasteManagementDataFR,
  miningAndMineralsDataFR,
  assetManagementDataFR,
  bankingDataFR,
  financialAdvisoryDataFR,
  financialServicesTaxDataFR,
  fintechDataFR,
  insuranceDataFR,
  healthcareDataFR,
  lifeScienceDataFR,
  privateEquityDataFR,
  professionalServiceDataFR,
  publicSectorDataFR,
  realEstateConstructionDataFR,
  mediaAndEntertainmentDataFR,
  technologyDataFR,
  telecommunicationDataFR,
  financialStatementAuditDataFR,
  ifrsAdvisoryServiceDataFR,
  otherAssuranceServiceDataFR,
  internalControlFrameworkDataFR,
  dealAdvisoryDataFR,
  restructuringDataFR,
  dueDiligenceDataFR,
  forensicServicesDataFR,
  riskAdvisoryDataFR,
  technologyAdvisoryServiceDataFR,
  valuationsDataFR,
  corporatetaxDataFR,
  mergerandacquisitionDataFR,
  transferpricingDataFR,
  valueaddedtaxDataFR,
  internationaltaxDataFR,
  excisetaxDataFR,
  taxrestructuringDataFR,
  economicsubstanceregulationsDataFR,
  marketResearchDataFR,
  businessConsultingDataFR,
  entitySetupDataFR,
  outsourcedFinanceRegulatoryComplianceDataFR,
  companySecretarialDataFR,
  financeAndAccountingDataFR,
  corporateAdvisoryServicesDataFR,
  expensesClaimManagementDataFR,
  payrollHrServicesDataFR,
  secondmentDataFR,
  treasuryServiceDataFR,
} from "../../../Data/French/HomeAboutSecDataFR";

export default function HomeAboutSec({ currentLanguage = "en" }) {
  const location = useLocation();
  const isFrench = currentLanguage === "fr";

  const isServicesPage = location.pathname.startsWith("/services");
  const isIndustriesPage = location.pathname.startsWith("/industries");

  // ---- INDUSTRY PATHS ----
  const isOilAndGasPage =
    location.pathname === "/industries/naturalresourcesandenergy/oilandgas";
  const isPowerAndUtilitiesPage =
    location.pathname === "/industries/naturalresourcesandenergy/powerandutilities";
  const isWasteManagementPage =
    location.pathname === "/industries/naturalresourcesandenergy/wastemanagement";
  const isMiningAndMineralsPage =
    location.pathname === "/industries/naturalresourcesandenergy/miningandminerals";
  const isAssetManagementPage =
    location.pathname === "/industries/financialservices/assetmanagement";
  const isBankingPage =
    location.pathname === "/industries/financialservices/banking";
  const isFinancialAdvisoryPage =
    location.pathname === "/industries/financialservices/financialadvisoryservices";
  const isFinancialServicesTaxPage =
    location.pathname === "/industries/financialservices/financialservicetax";
  const isFintechPage =
    location.pathname === "/industries/financialservices/fintech";
  const isInsurancePage =
    location.pathname === "/industries/financialservices/insurance";
  const isHealthcarePage = location.pathname === "/industries/healthcare";
  const isLifeSciencePage = location.pathname === "/industries/lifescience";
  const isPrivateEquityPage = location.pathname === "/industries/privateequity";
  const isProfessionalServicePage = location.pathname === "/industries/professionalservice";
  const isPublicSectorPage = location.pathname === "/industries/publicsector";
  const isRealEstateConstructionPage = location.pathname === "/industries/realestateconstruction";
  const isMediaAndEntertainmentPage =
    location.pathname === "/industries/technologymediaentertainmenttelecommunications/mediaandentertainment";
  const isTechnologyPage =
    location.pathname === "/industries/technologymediaentertainmenttelecommunications/technology";
  const isTelecommunicationPage =
    location.pathname === "/industries/technologymediaentertainmenttelecommunications/telecommunication";

  // ---- AUDIT & ASSURANCE SERVICES ----
  const isFinancialStatementAuditPage =
    location.pathname === "/services/auditandassurance/financialstatementaudit";
  const isIFRSAdvisoryServicePage =
    location.pathname === "/services/auditandassurance/ifrsadvisoryservice";
  const isOtherAssuranceServicePage =
    location.pathname === "/services/auditandassurance/otherassuranceservice";
  const isInternalControlFrameworkPage =
    location.pathname === "/services/auditandassurance/internalcontrolframework";

  // ---- ADVISORY SERVICES ----
  const isDealAdvisoryPage = location.pathname === "/services/advisory/dealadvisory";
  const isRestructuringPage = location.pathname === "/services/advisory/restructuring";
  const isDueDiligencePage = location.pathname === "/services/advisory/duediligence";
  const isForensicServicesPage = location.pathname === "/services/advisory/forensicservices";
  const isRiskAdvisoryPage = location.pathname === "/services/advisory/riskadvisory";
  const isTechnologyAdvisoryServicePage = location.pathname === "/services/advisory/technologyadvisoryservice";
  const isValuationsPage = location.pathname === "/services/advisory/valuations";

  // ---- TAXATION SERVICES ----
  const isCorporateTaxPage = location.pathname === "/services/taxation/corporatetax";
  const isMergerAndAcquisitionPage = location.pathname === "/services/taxation/mergerandacquisition";
  const isTransferPricingPage = location.pathname === "/services/taxation/transferpricing";
  const isValueAddedTaxPage = location.pathname === "/services/taxation/valueaddedtax";
  const isInternationalTaxPage = location.pathname === "/services/taxation/internationaltax";
  const isExciseTaxPage = location.pathname === "/services/taxation/excisetax";
  const isTaxRestructuringPage = location.pathname === "/services/taxation/taxrestructuring";
  const isEconomicSubstanceRegulationsPage = location.pathname === "/services/taxation/economicsubstanceregulations";

  // ---- STRATEGY & CORPORATE SERVICES PATHS ----
  const isMarketResearchPage = location.pathname === "/services/strategies/marketresearch";
  const isBusinessConsultingPage = location.pathname === "/services/strategies/businessconsulting";
  const isEntitySetupPage = location.pathname === "/services/corporateservices/entitysetup";
  const isOutsourcedFinanceCompliancePage = location.pathname === "/services/corporateservices/outsourcedfinanceregulatorycompliance";
  const isCompanySecretarialPage = location.pathname === "/services/corporateservices/companysecertarial";

  // ---- BUSINESS SERVICE OUTSOURCING PATHS ----
  const isFinanceAndAccountingPage = location.pathname === "/services/businessserviceoutsourcing/financeandaccounting";
  const isCorporateAdvisoryServicesPage = location.pathname === "/services/businessserviceoutsourcing/corporateadvisoryservices";
  const isExpensesClaimManagementPage = location.pathname === "/services/businessserviceoutsourcing/expensesclaimmanagement";
  const isPayrollHrServicesPage = location.pathname === "/services/businessserviceoutsourcing/payrollhrservices";
  const isSecondmentPage = location.pathname === "/services/businessserviceoutsourcing/secondment";
  const isTreasuryServicePage = location.pathname === "/services/businessserviceoutsourcing/treasuryservice";

  // ------------------ SELECT DATA BASED ON LANGUAGE ------------------
  let data;
  
  // DEFAULT
  if (isServicesPage) {
    data = isFrench ? servicesDataFR : servicesData;
  }

  // AUDIT & ASSURANCE
  if (isFinancialStatementAuditPage) {
    data = isFrench ? financialStatementAuditDataFR : financialStatementAuditData;
  } else if (isIFRSAdvisoryServicePage) {
    data = isFrench ? ifrsAdvisoryServiceDataFR : ifrsAdvisoryServiceData;
  } else if (isOtherAssuranceServicePage) {
    data = isFrench ? otherAssuranceServiceDataFR : otherAssuranceServiceData;
  } else if (isInternalControlFrameworkPage) {
    data = isFrench ? internalControlFrameworkDataFR : internalControlFrameworkData;
  }

  // ADVISORY
  else if (isDealAdvisoryPage) {
    data = isFrench ? dealAdvisoryDataFR : dealAdvisoryData;
  } else if (isRestructuringPage) {
    data = isFrench ? restructuringDataFR : restructuringData;
  } else if (isDueDiligencePage) {
    data = isFrench ? dueDiligenceDataFR : dueDiligenceData;
  } else if (isForensicServicesPage) {
    data = isFrench ? forensicServicesDataFR : forensicServicesData;
  } else if (isRiskAdvisoryPage) {
    data = isFrench ? riskAdvisoryDataFR : riskAdvisoryData;
  } else if (isTechnologyAdvisoryServicePage) {
    data = isFrench ? technologyAdvisoryServiceDataFR : technologyAdvisoryServiceData;
  } else if (isValuationsPage) {
    data = isFrench ? valuationsDataFR : valuationsData;
  }

  // TAXATION
  else if (isCorporateTaxPage) {
    data = isFrench ? corporatetaxDataFR : corporatetaxData;
  } else if (isMergerAndAcquisitionPage) {
    data = isFrench ? mergerandacquisitionDataFR : mergerandacquisitionData;
  } else if (isTransferPricingPage) {
    data = isFrench ? transferpricingDataFR : transferpricingData;
  } else if (isValueAddedTaxPage) {
    data = isFrench ? valueaddedtaxDataFR : valueaddedtaxData;
  } else if (isInternationalTaxPage) {
    data = isFrench ? internationaltaxDataFR : internationaltaxData;
  } else if (isExciseTaxPage) {
    data = isFrench ? excisetaxDataFR : excisetaxData;
  } else if (isTaxRestructuringPage) {
    data = isFrench ? taxrestructuringDataFR : taxrestructuringData;
  } else if (isEconomicSubstanceRegulationsPage) {
    data = isFrench ? economicsubstanceregulationsDataFR : economicsubstanceregulationsData;
  }

  // STRATEGIES & CORPORATE SERVICES
  else if (isMarketResearchPage) {
    data = isFrench ? marketResearchDataFR : marketResearchData;
  } else if (isBusinessConsultingPage) {
    data = isFrench ? businessConsultingDataFR : businessConsultingData;
  } else if (isEntitySetupPage) {
    data = isFrench ? entitySetupDataFR : entitySetupData;
  } else if (isOutsourcedFinanceCompliancePage) {
    data = isFrench ? outsourcedFinanceRegulatoryComplianceDataFR : outsourcedFinanceRegulatoryComplianceData;
  } else if (isCompanySecretarialPage) {
    data = isFrench ? companySecretarialDataFR : companySecretarialData;
  }

  // BUSINESS SERVICE OUTSOURCING
  else if (isFinanceAndAccountingPage) {
    data = isFrench ? financeAndAccountingDataFR : financeAndAccountingData;
  } else if (isCorporateAdvisoryServicesPage) {
    data = isFrench ? corporateAdvisoryServicesDataFR : corporateAdvisoryServicesData;
  } else if (isExpensesClaimManagementPage) {
    data = isFrench ? expensesClaimManagementDataFR : expensesClaimManagementData;
  } else if (isPayrollHrServicesPage) {
    data = isFrench ? payrollHrServicesDataFR : payrollHrServicesData;
  } else if (isSecondmentPage) {
    data = isFrench ? secondmentDataFR : secondmentData;
  } else if (isTreasuryServicePage) {
    data = isFrench ? treasuryServiceDataFR : treasuryServiceData;
  }

  // INDUSTRIES
  else if (isOilAndGasPage) {
    data = isFrench ? oilAndGasDataFR : oilAndGasData;
  } else if (isPowerAndUtilitiesPage) {
    data = isFrench ? powerAndUtilitiesDataFR : powerAndUtilitiesData;
  } else if (isWasteManagementPage) {
    data = isFrench ? wasteManagementDataFR : wasteManagementData;
  } else if (isMiningAndMineralsPage) {
    data = isFrench ? miningAndMineralsDataFR : miningAndMineralsData;
  } else if (isAssetManagementPage) {
    data = isFrench ? assetManagementDataFR : assetManagementData;
  } else if (isBankingPage) {
    data = isFrench ? bankingDataFR : bankingData;
  } else if (isFinancialAdvisoryPage) {
    data = isFrench ? financialAdvisoryDataFR : financialAdvisoryData;
  } else if (isFinancialServicesTaxPage) {
    data = isFrench ? financialServicesTaxDataFR : financialServicesTaxData;
  } else if (isFintechPage) {
    data = isFrench ? fintechDataFR : fintechData;
  } else if (isInsurancePage) {
    data = isFrench ? insuranceDataFR : insuranceData;
  } else if (isHealthcarePage) {
    data = isFrench ? healthcareDataFR : healthcareData;
  } else if (isLifeSciencePage) {
    data = isFrench ? lifeScienceDataFR : lifeScienceData;
  } else if (isPrivateEquityPage) {
    data = isFrench ? privateEquityDataFR : privateEquityData;
  } else if (isProfessionalServicePage) {
    data = isFrench ? professionalServiceDataFR : professionalServiceData;
  } else if (isPublicSectorPage) {
    data = isFrench ? publicSectorDataFR : publicSectorData;
  } else if (isRealEstateConstructionPage) {
    data = isFrench ? realEstateConstructionDataFR : realEstateConstructionData;
  } else if (isMediaAndEntertainmentPage) {
    data = isFrench ? mediaAndEntertainmentDataFR : mediaAndEntertainmentData;
  } else if (isTechnologyPage) {
    data = isFrench ? technologyDataFR : technologyData;
  } else if (isTelecommunicationPage) {
    data = isFrench ? telecommunicationDataFR : telecommunicationData;
  }

  // DEFAULT INDUSTRIES
  else if (isIndustriesPage) {
    data = isFrench ? industriesDataFR : industriesData;
  }

  // DEFAULT HOME
  else {
    data = isFrench ? aboutDataFR : aboutData;
  }

  return (
    <div
      className="about-wrapper section pb-0 pt-0"
      style={{
        background: isIndustriesPage ? "#F5F5F7" : "#ffffff",
        paddingLeft: isIndustriesPage ? "0" : "60px",
      }}
    >
      <div className="row align-items-center homesectiondisplay">
        <div className="col-12 col-md-6 mb-4 mb-md-0 single-img-padding">
          {isServicesPage && (
            <div className="single-img-wrapper">
              <img
                src="/assets/images/SmartTechIMG.png"
                alt="services audit"
                className="single-full-img"
              />
            </div>
          )}

          {isIndustriesPage && (
            <div className="industry-img-wrapper">
              <img
                src="/assets/images/industry-img.png"
                alt="industry"
                className="industry-full-img"
              />
            </div>
          )}

         {!isServicesPage && !isIndustriesPage && (
            <div className="image-grid">
              <img src="/assets/images/homeaboutimg.png" alt="" className="w-100 h-100"/>  
            </div>
          )}
 
        </div>

        {/* RIGHT SIDE */}
        <div className="col-12 col-md-6 mobile-width">
          {!isIndustriesPage && (
            <div className="d-flex">
              <div className="d-flex align-items-center justify-content-center mb-2">
                <div className="about-line me-3"></div>
                <p className="service-subtitle mb-0">{data.subtitle}</p>
              </div>
            </div>
          )}

          <h2 className="about-title">{data.title}</h2>

          <p className="about-text">{data.desc1}</p>
          {data.desc2 && <p className="about-text mb-4">{data.desc2}</p>}

          {!isServicesPage && !isIndustriesPage && (
            <button className="read-btn">
              {isFrench ? "Explorer Notre Histoire" : "Explore Our Story"}
              <img
                src="/assets/icons/RightArrow.png"
                alt="arrow"
                className="arrow-icon"
              />
            </button>
          )}

          {/* DEFAULT INDUSTRY STATS */}
          {isIndustriesPage &&
            !isOilAndGasPage &&
            !isPowerAndUtilitiesPage &&
            !isWasteManagementPage &&
            !isMiningAndMineralsPage &&
            !isAssetManagementPage &&
            !isBankingPage &&
            !isFinancialAdvisoryPage &&
            !isFinancialServicesTaxPage &&
            !isFintechPage &&
            !isInsurancePage &&
            !isHealthcarePage &&
            !isLifeSciencePage &&
            !isPrivateEquityPage &&
            !isProfessionalServicePage &&
            !isPublicSectorPage &&
            !isRealEstateConstructionPage &&
            !isMediaAndEntertainmentPage &&
            !isTechnologyPage &&
            !isTelecommunicationPage && (
              <div className="industry-stats">
                <div className="stat-box">
                  <h3>$50B+</h3>
                  <p>{isFrench ? "Actifs Sous Gestion" : "Assets Under Management"}</p>
                </div>
                <div className="stat-box">
                  <h3>25+</h3>
                  <p>{isFrench ? "Années d'Expérience" : "Years Experience"}</p>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}